import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Citation, EditableItem } from '®shared/reading-list/models';

@Component({
  selector: 'rl-item-citation',
  templateUrl: './item-citation.component.html',
})
export class ItemCitationComponent {
  @Input() citation?: Citation;
  @Input() isExpanded?: boolean;
  @Input() item: EditableItem;
  @Input() listId: string;
  @Output() itemClicked = new EventEmitter<any>();
}
